import { Controller, useFormContext } from 'react-hook-form';
import { EmployeeFormValues, SelectItemType } from '@/types';
import { OrganType } from '@/api/apis/case';
import { CsOrganCertificationField } from './CsOrganCertificationField';

type CsOrganCertificationRowProps = {
  name: 'shadowOrganSpecializations' | 'proctorOrganSpecializations';
  title: string;
  items: SelectItemType[];
  isDisabled?: boolean;
};

export const CsOrganCertificationRow = ({ name, title, items, isDisabled }: CsOrganCertificationRowProps) => {
  const { control } = useFormContext<EmployeeFormValues>();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange }, fieldState: { invalid, error } }) => (
        <CsOrganCertificationField
          value={(value as OrganType[]) ?? []}
          onChange={onChange}
          invalid={invalid}
          errorMessage={error?.message}
          title={title}
          items={items}
          isDisabled={isDisabled}
        />
      )}
    />
  );
};
